module.exports = __webpack_public_path__ + "img/member_idcard_image2.23366aa0.png";